import MovingArrow from '@images/icons/moving-arrow.svg?react'
import type { ReactNode } from 'react'

type ApplicationFeeButtonProps = {
  icon: ReactNode
  caption: string
  onClick: () => void
}

const ApplicationFeeButton = ({ icon, caption, onClick }: ApplicationFeeButtonProps) => (
  <div onClick={onClick} className='onboarding-application-button'>
    <div className='onboarding-application-button-information'>
      <div className={`onboarding-application-icon ${caption}`}>{icon}</div>
      <span>{caption}</span>
    </div>
    <div className='onboarding-application-button-arrow'>
      <MovingArrow />
    </div>
  </div>
)

export default ApplicationFeeButton
